import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Link } from 'react-router-dom'
import { Queries, Mutations } from '../../../../graphql'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, Radio, DatePicker, Avatar, Modal, InputNumber, TimePicker } from 'antd'
import Container from '../../../../components/user/Container'
import FromInput from '../../../../components/user/from/Input'
import { numberWithCommas } from '../../../../utils/number'
import { checkMoreThanLess, changeFormatdate, getTimeFromMins, changeFormatdateThai } from '../../../../utils/formatdate'
import moment from 'moment'
import { NIL } from 'uuid'
import ModalConfirmForm from '../../../../components/user/ModalConfirmForm'
import { alertMessage } from '../../../../utils/message'
import { timeLeave, checkNameApproves } from '../../../../utils/leave'
import { profileObjectKey, employeeDetailObjectKey } from '../../../../utils/auth'
import { checkLinkURL } from '../../../../utils/auth'
import TableCCEmail from '../../../../components/user/Leave/TableCCEmail'
import { convertLeaveDayUnit } from '../../../../utils/changesString'

import ComponetsRemarkText from '../Components/remarkText'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;
const { TextArea } = Input;

const DOCUMENT_TYPE = [
    { label: 'ใบรับรองแพทย์', value: 'ใบรับรองแพทย์' },
   //  { label: 'ใบสูติบัตร', value: 'ใบสูติบัตร' },
    { label: 'อื่น ๆ', value: 'อื่น ๆ' },
]

const newsDataProfile = '';
const format = 'HH:mm';

class Withdraw extends Component {
	state = {
		loading:false,
		dataTalbeUploads: [
			{
				documentType: null,
            description:null,
				attachFile:null,
            statusFile:false
			},
		],
      columns: [
         {
            title: 'ประเภทเอกสาร',
            dataIndex: 'documentType',
            align:'center',
            vertical:'top',
            render: (item, record, index) => {
               return(
                  <>
                        <Form.Item label={""}>
                           { this.props.form.getFieldDecorator("documentType"+index, {
                              initialValue: item ? item : [],
                              rules:  [{ 
                                    required: (record.description) || (record.attachFile) ? true : false,
                                    message: 'กรุณาระบุ ประเภทเอกสาร',
                              }],
                           })(
                              <Select 
                                    style={{ width: "100%" }}
                                    onChange={ (e) => this.onChangeValueForm(index, e, 'documentType') }
                                    showSearch
                                    placeholder="กรุณาระบุ "
                                    optionFilterProp="children"
                              >
                                    {
                                       DOCUMENT_TYPE.map((valuesLabel, keys)=>{
                                          return <Option value={valuesLabel.value}>{ valuesLabel.label }</Option>
                                       })
                                    }
                              </Select>
                           )}
                        </Form.Item>
                  </>
               )
            }
         },
         {
               title: 'รายละเอียดเพิ่มเติม',
               dataIndex: 'description',
               vertical:'top',
         align:'center',
               render: (item, record, index) => {
                  return(
                     <>
                           <Form.Item label={""}>
                              { this.props.form.getFieldDecorator("description"+index, {
                                 initialValue: item,
                                 rules:  [{ 
                                       required: (record.documentType) || (record.attachFile) ? true : false,
                                       message: 'กรุณาระบุรายละเอียด',
                                 }],
                              })(
                                 <Input 
                                       // defaultValue={item} 
                                       onBlur={ (e) => this.onChangeValueForm(index, e, 'description') }
                                 />
                              )}
                           </Form.Item>
                     </>
                  )
               }
         },
         {
               title: 'เอกสารแนบ',
               dataIndex: '7',
               width:'200px',
               vertical:'top',
               align:'center',
               render: (item, record, index) => {
                  return (
                     <>
                        { this.inputFormUploads(index) }
                     </>
                  )
               }
         },
         {
               title: 'จัดการ',
               dataIndex: '7',
               width:'20px',
               vertical:'top',
         align:'center',
               render: (item, record, index) => {
                  return this.showDetailBtnInput(record, index)
               }
         },
      ],
      dataTalbeLength:1,
      preLoadOnsubmit: false,
      detailProfile:null,
      dropdownApproverMedical:[],
      preLoadOndropdownApproverMedical: false,
		dateTimeValue:moment(),
      searchUser:null,
      leaveTypeId:null,
      leaveDay:null,
      showleaveDay:null,
      currentLeaveDay:null,
      remainLeaveDay:null,
      disabledDateStart:moment(),
		endStartValues:moment(),
      dropdownLeaveType:[],
      dropdowndurationType:[],
      empCode:null,
      isCanLeaveOver:null,
      maxLeaveDay:null,
      minLeaveDay:null,
      reqAttachDay:null,
      reqAttachDayStatus:false,
      disabledDurationType:false,
      dataTalbeAttendance: [
			{
				dateFirstLeave: moment(),
                empCodeLeave:5594825,
                timeFirst: moment(),
				timeLast: moment().add(5, 'hours'),
                statusFile:false
			},
            {
				dateFirstLeave: moment().add(1, 'days'),
                empCodeLeave:5594825,
                timeFirst: moment().add(2, 'hours'),
				timeLast: moment().add(7, 'hours'),
                statusFile:false
			},
            {
				dateFirstLeave: moment().add(2, 'days'),
                empCodeLeave:5594825,
                timeFirst: moment().add(-7, 'hours'),
				timeLast: moment().add(6, 'hours'),
                statusFile:false
			},
		],
      columnsAttendance: [
         {
               title: 'วันที่ขอลา',
               dataIndex: 'dateFirstLeave',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <label>
                              { changeFormatdate(item) }
                           </label>
                           {/* <Form.Item label={""}>
                              { this.props.form.getFieldDecorator("documentType"+index, {
                                 initialValue: item,
                                 rules:  [{ 
                                       required: record.description ? true : false,
                                       message: 'กรุณาระบุ ประเภทเอกสาร',
                                 }],
                              })(
                                 <Input 
                                       disabled={true}
                                 />
                              )}
                           </Form.Item> */}
                     </>
                  )
               }
         },
         {
               title: 'รหัสกะงาน',
               dataIndex: 'empCodeLeave',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <label>
                              { item }
                           </label>
                     </>
                  )
               }
         },
         {
               title: 'เวลาเริ่มต้น',
               dataIndex: 'timeFirst',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <label>
                              { moment(item).format('HH:mm') }
                           </label>
                     </>
                  )
               }
         },
         {
               title: 'เวลาสิ้นสุด',
               dataIndex: 'timeLast',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <label>
                              { moment(item).format('HH:mm') }
                           </label>
                     </>
                  )
               }
         },
         {
               title: 'เวลาเริ่มต้น',
               dataIndex: '655',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <Form.Item label={""}>
                              { this.props.form.getFieldDecorator("655"+index, {
                                 initialValue: item,
                                 rules:  [{ 
                                       message: 'กรุณาระบุ ประเภทเอกสาร',
                                 }],
                              })(
                                 <TimePicker 
                                       format={format} 
                                       placeholder="" 
                                       // disabledHours={() => this.getDisabledHours(record)}
                                       // disabledMinutes={(e) => this.getDisabledMinutes(e, record)}
                                 />
                              )}
                           </Form.Item>
                     </>
                  )
               }
         },
         {
               title: 'เวลาสิ้นสุด',
               dataIndex: '444',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <Form.Item label={""}>
                              { this.props.form.getFieldDecorator("444"+index, {
                                 initialValue: item,
                                 rules:  [{ 
                                       message: 'กรุณาระบุ ประเภทเอกสาร',
                                 }],
                              })(
                                 <TimePicker format={format} placeholder="" />
                              )}
                           </Form.Item>
                     </>
                  )
               }
         },
         {
               title: 'จำนวน ซม.',
               dataIndex: '123',
         align:'center',
               vertical:'top',
               render: (item, record, index) => {
                  return(
                     <>
                           <Form.Item label={""}>
                              { this.props.form.getFieldDecorator("123"+index, {
                                 initialValue: item,
                                 rules:  [{ 
                                       message: 'กรุณาระบุ ประเภทเอกสาร',
                                 }],
                              })(
                                 <Input 
                                       disabled={true}
                                 />
                              )}
                           </Form.Item>
                     </>
                  )
               }
         },
      ],
      loadingleaveDayAllData:true,
      loadingFullpage:true,
      leaveDayAllData:[],
      shiftId: null,
      leaveStartTime: null,
      leaveEndTime: null,
      leaveHour: null,
      leaveTypeCategory: null,
      ModalConfirmFormTitle:null,
      ModalConfirmFormSubTitle:null,
      ModalConfirmFormShowModal:false,
      ModalConfirmFormBtnOk:null,
      ModalConfirmFormBtnCancel:null,
      ModalConfirmFormValue:null,
      ModalConfirmFormStatus:null,
		ModalConfirmFormMessage:null,
      ModalFormTextArea:false,
      ModalFormTextAreaRequie: false,
      earlyLeaveDay: null,
      backLeaveDay: null,
      approveStatus: "W",
      labelTypeLeave: null,
      historyYear: null,
      dropdownTimeLeave: [],
      remarkText: null,
      manualLeave: [],
      modalGuideLineTax: false,
      preloadProfile: true,
      isPlasma: 0,
      fiscalYear: null
	}

    dateFormatNumber = (values) =>{
        let valueReturn = this.props.form.getFieldValue(values)
        return changeFormatdate(moment(valueReturn))
    }

    dropdownLeaveType = async ()=>{
        const { client, location, match } = this.props
        const { empCode } = this.state

        await this.setState({
            // loadingFullpage: true
        })
        
        const { data, errors } = await client.query({
            query: Queries.dropdownLeaveType,
            variables:{
                // empCode
                isReqByEmp:true
            }
        })

        if(data.dropdownLeaveType){
            await this.setState({
                dropdownLeaveType: data.dropdownLeaveType,
                loadingFullpage: false
            })
        }else{
           await this.setState({
               loadingFullpage: false
           })
        }
    }

    fetchLeaveDay = async() =>{
        const { client, location, match } = this.props
        const { leaveTypeId, isCanLeaveOver, disabledDateStart } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchLeaveDay,
            variables:{
                leaveTypeId,
                reqLeaveDate: disabledDateStart
            }
        })

        console.log('data.fetchLeaveDay',data.fetchLeaveDay)

        if(data.fetchLeaveDay){
            await this.setState({
                showleaveDay: data.fetchLeaveDay.leaveDay,
                currentLeaveDay: data.fetchLeaveDay.currentLeaveDay,
                remainLeaveDay: data.fetchLeaveDay.remainLeaveDay,
            })
        }else{
            await this.setState({
                showleaveDay: null,
                currentLeaveDay: null,
                remainLeaveDay: null
            })
        }
    }

    onChangeValueDateStart = async (e) =>{
        const { endStartValues, leaveTypeId, leaveTypeCategory, leaveDay } = this.state
		// this.form.resetFields('endDate')
      await this.props.form.setFieldsValue({
         shiftCode: null,
         shiftTime: null,
         leaveStartTime: null,
         leaveEndTime: null,
         leaveHour: null
      })
      
      if(leaveTypeCategory == 'Custom'){
         if(leaveDay == '1'){
            await this.setState({
               leaveTypeCategory: 'Full'
            })
         }
      } else if (leaveTypeCategory == 'H1' || leaveTypeCategory == 'H2') {
         await this.setState({
            leaveTypeCategory: 'Full'
         })
      }
      if(e){
         this.setState({
            disabledDateStart: moment(e),
         })
         let checkDatemore = checkMoreThanLess(e, endStartValues)

         if(leaveTypeId){
            if(checkDatemore){
               this.props.form.setFieldsValue({
                  leaveEndDate: checkDatemore,
               })
               this.setState({
                  endStartValues: checkDatemore
               })

               if(checkDatemore){
                  await Promise.all(
                     [
                        this.fetchWorkingDay(e, checkDatemore),
                        this.fetchLeaveDay()
                     ]
                  )
               }
            }else{
               if(endStartValues){
                  await Promise.all(
                     [
                        this.fetchWorkingDay(e, endStartValues),
                        this.fetchLeaveDay()
                     ]
                  )
               }
            }
         }else{
            if(checkDatemore){
               await this.props.form.setFieldsValue({
                  leaveEndDate: checkDatemore,
               })
               await this.setState({
                  endStartValues: checkDatemore
               })
            }
         }
      }
	}

	onChangeValueDateEnd = async (e) =>{
      const { disabledDateStart, leaveTypeCategory, leaveDay } = this.state
      
      await this.props.form.setFieldsValue({
         shiftCode: null,
         shiftTime: null,
         leaveStartTime: null,
         leaveEndTime: null,
         leaveHour: null
      })

      if(leaveTypeCategory == 'Custom' ){
         if(leaveDay == '1'){
            await this.setState({
               leaveTypeCategory: 'Full'
            })
         }
      }

      if(e){
         await this.setState({
            endStartValues: moment(e),
         })

         if(e && disabledDateStart){
            this.fetchWorkingDay(disabledDateStart, e)
         }
      }
	}

    fetchWorkingDay = async(leaveStartDate, leaveEndDate) =>{
        const { client, location, match } = this.props
        const { empCode, leaveTypeId, reqAttachDay, dropdowndurationType, leaveTypeCategory } = this.state

         await this.setState({
            loadingFullpage: true
         })

        const { data, errors } = await client.query({
            query: Queries.fetchWorkingDay,
            variables:{
                leaveTypeId,
                leaveStartDate,
                leaveEndDate
            }
        })

         const date = new Date(leaveStartDate);
         let convertYear = date.getFullYear(); 
         const octoberFirst = new Date(convertYear, 9, 1); 
         if (date > octoberFirst) {
            convertYear += 1; 
         }

        if(data.fetchWorkingDay){
            await this.setState({
                leaveDay: data.fetchWorkingDay.day,
                fiscalYear: convertYear.toString()
            })

            await Promise.all(
               [
                  this.fetchApproverLeave(data.fetchWorkingDay.day),
                  this.props.form.setFieldsValue({
                     leaveDay: data.fetchWorkingDay.day,
                     durationType: leaveTypeCategory
                 })
               ]
            )
            
            if(reqAttachDay !== 0){
                if(reqAttachDay >= data.fetchWorkingDay.day){
                    await this.setState({
                        reqAttachDayStatus:false
                    })
                }else{
                    this.setState({
                        reqAttachDayStatus:true
                    })
                }
            }

            if(leaveTypeCategory == 'Custom'){
               await this.setState({
                  disabledDurationType: false
              })
            }else if(dropdowndurationType.length == 1){
                await this.setState({
                    disabledDurationType: true,
                    loadingFullpage: false
                })
            }else if(!data.fetchWorkingDay.day){
                await this.setState({
                    disabledDurationType: false,
                    loadingFullpage: false
                })
            }else if(data.fetchWorkingDay.day > 1){
                await this.setState({
                    disabledDurationType: true,
                    loadingFullpage: false
                })
            }else{
                await this.setState({
                    disabledDurationType: false,
                    loadingFullpage: false
                })
            }

        }else{
           await this.setState({
               loadingFullpage: false
           })
        }
        
    }

    onChangeTypeLeave = async (leaveTypeId)=>{
        const { dropdownLeaveType } = this.state

        await this.setState({
            loadingFullpage:true
        })
        
        if(leaveTypeId){
            // console.log('dropdownLeaveType',dropdownLeaveType)
            dropdownLeaveType.filter(valuesName => valuesName.value == leaveTypeId).map(async (valueArray) => {
                await this.setState({
                    dropdowndurationType : valueArray.dropdownDurationType,
                    isCanLeaveOver: valueArray.isCanLeaveOver,
                    maxLeaveDay: valueArray.maxLeaveDay,
                    minLeaveDay: valueArray.minLeaveDay,
                    reqAttachDay: valueArray.reqAttachDay,
                    earlyLeaveDay: valueArray.earlyLeaveDay,
                    backLeaveDay: valueArray.backLeaveDay,
                    labelTypeLeave: valueArray.label
                })

            })
            await this.setState({
                leaveTypeId
            })

            let leaveStartDate = this.props.form.getFieldValue("leaveStartDate");
            let leaveEndDate = this.props.form.getFieldValue("leaveEndDate");
            if(leaveStartDate && leaveEndDate){
               await Promise.all(
                  [
                     this.fetchWorkingDay(leaveStartDate, leaveEndDate),
                     this.fetchLeaveDay()
                  ]
               )
            }

           
            await this.props.form.setFieldsValue({
            	// leaveStartDate: moment(),
            	// leaveEndDate: moment(),
               durationType: "Full",
               shiftCode: null,
               shiftTime: null,
               leaveStartTime: null,
               leaveEndTime: null,
               leaveHour: null
            })

            await this.setState({
                loadingFullpage:false,
                leaveTypeCategory: "Full",
            })
            
        }else{
            await this.setState({
                loadingFullpage:false
            })
        }
    }

    fetchApproverLeave = async (leaveDay) =>{
        const { client, location, match } = this.props
        const { empCode, leaveTypeId, fiscalYear } = this.state
        await this.setState({
            loadingFullpage: true,
            preLoadOndropdownApproverMedical: true
        })
        const { data, errors } = await client.query({
            query: Queries.fetchApproverLeave,
            variables:{
                leaveTypeId,
                leaveDay,
                fiscalYear
            }
        })

        console.log('data.fetchApproverLeave', data.fetchApproverLeave)

        if(data.fetchApproverLeave){
            await this.setState({
                dropdownApproverMedical: data.fetchApproverLeave,
                preLoadOndropdownApproverMedical: false,
                loadingFullpage: false
            })
        }else{
            await this.setState({
                dropdownApproverMedical: [],
                preLoadOndropdownApproverMedical: false,
                loadingFullpage: false
            })
        }
    }

    employeeDetailProfileForLeave = async () => {
      const { client, location, match } = this.props
      const { empCode } = this.state
      const { data, errors } = await client.query({
          query: Queries.employeeDetailProfileForLeave,
          variables:{
              empCode,
          }
      })

      if(data.employeeDetailProfileForLeave){
          await this.setState({
              detailProfile: data.employeeDetailProfileForLeave,
              preloadProfile: false
          })

          await this.dropdownLeaveType();
      }else{
          await this.setState({
              detailProfile:null,
              preloadProfile: false
            //   loadingFullpage:false
          })
      }
   }

      fetchProfileForLeave = async () => {
        const { client, location, match } = this.props
        const { posId } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchProfileForLeave,
        })
        await this.setState({
            detailProfile: data.fetchProfileForLeave,
            empCode:data.fetchProfileForLeave.employeeCodes,
            isPlasma: data.fetchProfileForLeave.isPlasma
        })
    }

    showDetailBtnInput = (record, arrayId) =>{
        const { dataTalbeUploads } = this.state
        return(
            <>
                {
                    dataTalbeUploads.length > 1 ? 
                            <Avatar 
                                shape="square"  
                                icon={<Icon type="delete" />} 
                                className="mr-1 mb-1 bg-red"  
                                onClick={ () => this.destroyArrayDataUploads(arrayId) }
                                style={{ cursor: 'pointer', background:"red" }}
                            />
                    : 
                        <Avatar 
                            shape="square"  
                            icon={<Icon type="delete" />} 
                            className="mr-1 mb-1 bg-red"  
                            // onClick={ () => this.destroyArrayDataUploads(arrayId) }
                            style={{ cursor: 'not-allowed' }}
                            disabled={true}
                        />
                }
            </>
        )
    }

    onChangeValueForm = async (arrayId, values, name) =>{
        const { dataTalbeUploads } = this.state
        let dataSourceitems = [...this.state.dataTalbeUploads];
        let item = {...dataSourceitems[arrayId]};

        if(name == 'description'){
            item.description = values.target.value
        }else if(name == 'documentType'){
            item.documentType = values
            item.statusFile = values == 'อื่น ๆ' ? true : false
        }

        dataSourceitems[arrayId] = item;

        await this.setState({
            dataTalbeUploads:dataSourceitems
        },async () => {
            // await this.setSummary()
			// this.cllBackSetValueContactNumber()
        })
    }

    destroyArrayDataUploads =  async (arrayId) =>{
        const { form } = this.props
        const { dataTalbeUploads } = this.state
        var arrayDataSource = [...this.state.dataTalbeUploads];
		arrayDataSource.splice(arrayId, 1);

		await this.setState({
			dataTalbeUploads:arrayDataSource,
            // dataTalbeLength: lengthData
		},async() => {
            let lengthData = arrayDataSource.length;
            await this.setState({
                dataTalbeLength: lengthData
            })

            arrayDataSource.map(async (valuesTable, keysTable) =>{
                let documentType = `documentType${keysTable}`
                let description = `description${keysTable}`
                // "documentType"+index
                await this.props.form.setFieldsValue({
                    [documentType]: valuesTable.documentType,
                    [description]: valuesTable.description,
                })
            })
            
			// this.cllBackSetValueContactNumber()
		})
    }

    showDataInputUploads = async () =>{
        const { dataTalbeUploads, reqAttachDayStatus } = this.state
        const rows = {
            documentType: null,
            statusFile: false,
            description: null,
            attachFile: null,
        }
        await this.setState(prevState => ({
            dataTalbeUploads: [...prevState.dataTalbeUploads, rows],
        }), async () => {
            let lengthData = dataTalbeUploads.length+1;
            await this.setState({
                dataTalbeLength: lengthData
            })
        })

        console.log("dataTalbeUploads",dataTalbeUploads)
    }

    handleAdd = async (images, arrayId ) => {
        const { dataTalbeUploads, reqAttachDayStatus } = this.state
        if(images){
         const isLt2M = images.size / 1024 / 1024 < 1;
         const fileType = images.name.substr(images.name.lastIndexOf("."));
         const dotIndex = images.name.indexOf(fileType)
         const fileName = images.name.substring(0, dotIndex)

         console.log("out if file",images)
         if(images.type == 'image/jpeg' || images.type == 'application/pdf' || images.type == 'image/png'){
            console.log("in if file",images)
			   if (!isLt2M) {
               message.error('ไฟล์ขนาดใหญ่เกิน 1MB กรุณาระบุ ไฟล์ใหม่อีกครั้ง');
                  let dataSourceitems = [...this.state.dataTalbeUploads];
                  let item = {...dataTalbeUploads[arrayId]};
                  item = {
                     documentType: item.documentType,
                     statusFile: item.documentType == 'อื่น ๆ' ? true : false,
                     description: item.description,
                     attachFile: null,
                  }
                  dataSourceitems[arrayId] = item;

                  await this.setState(({
                     dataTalbeUploads: dataSourceitems,
                  }), () => {
                     // this.cllBackSetValueOrganizatuions()
                  })
            } else if (fileName.includes(".")) {
               message.error('ชื่อไฟล์ไม่สามารถมีจุด (.) ได้ กรุณาเลือกไฟล์ใหม่อีกครั้ง');
            } else{
                  let dataSourceitems = [...this.state.dataTalbeUploads];
                  let item = {...dataTalbeUploads[arrayId]};
                  item = {
                     documentType: item.documentType,
                     statusFile: item.documentType == 'อื่น ๆ' ? true : false,
                     description: item.description,
                     attachFile: images,
                  }
                  dataSourceitems[arrayId] = item;

                  await this.setState(({
                     dataTalbeUploads: dataSourceitems,
                  }), () => {
                     // this.cllBackSetValueOrganizatuions()
                  })
            }
         }else{
            alertMessage("กรุณาแนบไฟล์ที่เป็นนามสกุล .jpg, .png หรือ .pdf")
         }
        }
	}

    onClickToNewTab = (typeFile) =>{
        const { linkNewTab } = this.state
        if(typeFile !== "application/pdf"){
            var win = window.open();
            win.document.write('<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="' + linkNewTab  + '" style="max-width:100%;height:100%"/></div>');
        }else{
            var win = window.open();
            win.document.write('<iframe src="' + linkNewTab  + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
        }
    }

    modalShowFileCreate = async (dataFile, title) =>{
         const { linkNewTab } = this.state
        var url = URL.createObjectURL(dataFile)
        const reader = new FileReader();
        if( dataFile.type !== "application/pdf"){
            reader.readAsDataURL(dataFile)
            reader.onloadend = async (e) => {
                var dataURL = reader.result;
                await this.setState({
                    linkNewTab: dataURL
                })

                Modal.info({
                  className:"modalFickIcons pt-4",
                  title: "ไฟล์อัปโหลดเอกสารแนบ",
                  width:"800px",
                  content: (
                      <div >
                           <hr></hr>
                           <div className="pt-4">
                              <Row  gutter={16} type="flex" justify="left" align="top" >
                                 <Col span={8} style={{ display:"block"}}>
                                    <div style={{ width:"100%", height: "200px", padding:"10px 55px" }} align="center" className="block-show-image-modal">
                                       <img src={dataURL} className="zoom-in"/>
                                       <a onClick={()=>this.onClickToNewTab(dataFile.type)} className="icons-delect-images">
                                          <Icon type="eye" style={{ color:"#fff" }}/>
                                       </a>
                                    </div>
                                 </Col>
                              </Row>
                          </div>
                      </div>
                  ),
                  okText: 'ปิด',
                  onOk() {},
              });
            };
        }else{
            reader.readAsDataURL(dataFile)
            reader.onloadend = async (e) => {
                var dataURL = reader.result;
                // var output = document.getElementById('show-pdf-popup');
                // output.href = dataURL;
                await this.setState({
                    linkNewTab: dataURL
                })

                Modal.info({
                  className:"modalFickIcons pt-4",
                  title: "ไฟล์อัปโหลดเอกสารแนบ",
                  width:"800px",
                  content: (
                      <div >
                           <hr></hr>
                           <div className="pt-4">
                              <Row  gutter={16} type="flex" justify="left" align="top" >
                                 <Col span={8} style={{ display:"block"}}>
                                    <div style={{ width:"100%", height: "200px" }} align="center" className="block-show-image-modal">
                                       <a onClick={()=>this.onClickToNewTab(dataFile.type)} className="color-white">
                                          <Icon type="file-pdf" /><br></br>
                                          ดูไฟล์ PDF
                                       </a>
                                    </div>
                                 </Col>
                              </Row>
                          </div>
                      </div>
                  ),
                  okText: 'ปิด',
                  onOk() {},
              });
            };
        }
    }
    

    inputFormUploads = (arrayId) =>{
        const { dataTalbeUploads } = this.state
        let fileName = dataTalbeUploads[arrayId].attachFile ? dataTalbeUploads[arrayId].attachFile.name : ""
        let fileNameShow = fileName.length <= 10 ? fileName : fileName.slice(0,10)+'...'+fileName.slice(-4) 
        return(
            <>
                <label for={"input-file-"+arrayId} class="custom-file-upload">
                    <p className="py-2 px-4 mb-0" align={"center"} style={{ backgroundColor:"#8d0e14", color:"#fff" }}>
                        อัปโหลด
                    </p>
                    <p style={{ fontSize:"12px" }} className="my-2">แนบไฟล์ที่เป็นนามสกุล<br></br> .jpg, .png หรือ .pdf</p>
                </label>
                <span className={ fileName ? '' : "color-red"  }>
                    { 
                        fileName ? 
                        <Text 
                            onClick={ () => { this.modalShowFileCreate(dataTalbeUploads[arrayId].attachFile, 'เอกสาร') }} 
                            style={{ cursor:"pointer" }}
                            className="btn-show-fileuploads"
                        >
                            {/* {fileNameShow} */}
                            ดูไฟล์อัปโหลด
                        </Text>
                         :
                         <span id={"showTextUplodas"+arrayId}>กรุณาเลือก อัปโหลดรูปภาพหรือไฟล์</span>
                    }
                </span>
                <input
                    id={"input-file-"+arrayId}
                    className="input-file"
                    // name={uploadName}
                    type="file"
                    accept="file_extension"
                    accept="image/png, image/jpeg, application/pdf"
                    // rules={ true }
                    onChange={e => this.handleAdd(e.target.files[0],arrayId)}
                    accept="image/png, image/jpeg, application/pdf"
                />
            </>
        )

    }

    sendToCreateLeave = async (values) => {
        const { form, client } = this.props
        const { 
            dropdownApproverMedical, 
            dataTalbeUploads, 
            detailProfile, 
            withdrawFirstName, 
            withdrawLastName, 
            summaryTotalTable,
            summaryTotal,
            withdrawIdCard,
            ageValue,
            relationValue,
            reqAttachDayStatus,
            reqAttachDay,
            leaveDay,
            ModalConfirmFormStatus,
            shiftId,
            leaveHour
        } = this.state

        this.setState({
            preLoadOnsubmit: true,
            loadingFullpage: true
        })
        
        await this.hideModalConfirm()

         try {
            let approversDropDown = []
            let attachFiles = []
            let checkModal = false

            if(dataTalbeUploads.length !== 0){
               dataTalbeUploads.map((valuesFile , keyValuesFile) =>{
                     if (reqAttachDay != 0 && reqAttachDay < leaveDay) {
                        if(!valuesFile.description || !valuesFile.attachFile){
                           document.getElementById('showTextUplodas'+keyValuesFile).classList.add("color-red")
                           checkModal = true
                        }
                     }else if(valuesFile.documentType == 'อื่น ๆ'){
                        if(!valuesFile.description || !valuesFile.attachFile ){
                           document.getElementById('showTextUplodas'+keyValuesFile).classList.add("color-red")
                           checkModal = true
                        }
                     }else if(valuesFile.documentType){
                        if(!valuesFile.attachFile){
                           document.getElementById('showTextUplodas'+keyValuesFile).classList.add("color-red")
                           checkModal = true
                        }
                     }else if(valuesFile.attachFile){
                        if(!valuesFile.documentType){
                           document.getElementById('showTextUplodas'+keyValuesFile).classList.add("color-red")
                           checkModal = true
                        }
                     }else if(valuesFile.documentType){
                        if(!valuesFile.attachFile){
                           document.getElementById('showTextUplodas'+keyValuesFile).classList.add("color-red")
                           checkModal = true
                        }
                     }

                     if(valuesFile.documentType || valuesFile.description || valuesFile.attachFile){
                        let dataArray = {
                           documentType: valuesFile.documentType ? valuesFile.documentType : '',
                           description: valuesFile.description ? valuesFile.description : '',
                           attachFile: valuesFile.attachFile,
                        }

                        attachFiles.push(dataArray)
                     }
               })
            }

            if(checkModal){
               Modal.error({
                     title: 'กรุณาอัปโหลดรูปภาพหรือไฟล์',
                     className:'custom-modal-error',
                     okText: 'ตกลง',
               });
               await this.setState({
                     preLoadOnsubmit: false,
                     loadingFullpage: false
               })
            }else{
               Object.keys(values).filter(valuesName => valuesName.includes("approversDropDown")).map(keyValueArray => {
                     if(values[keyValueArray]){
                        dropdownApproverMedical.map((valuseLabel, keysLabel) =>{
                           valuseLabel.users.filter(valuesName => valuesName.value == values[keyValueArray]).map(valueArray => {
                                 let dataArray = {
                                    level: valuseLabel.level,
                                    role: valuseLabel.approveType,
                                    empCode: valueArray.value,
                                    canEdit: valuseLabel.canEdit
                                 }
         
                                 approversDropDown.push(dataArray)
                           })
                        })
                     }else{
                        dropdownApproverMedical[keyValueArray.replace("approversDropDown", "")].users.map((valuseUser, keysLabel) =>{
                           let dataArray = {
                                 level: dropdownApproverMedical[keyValueArray.replace("approversDropDown", "")].level,
                                 role: dropdownApproverMedical[keyValueArray.replace("approversDropDown", "")].approveType,
                                 empCode: valuseUser.value,
                                 canEdit: dropdownApproverMedical[keyValueArray.replace("approversDropDown", "")].canEdit
                           }
   
                           approversDropDown.push(dataArray)
                        })
                     }
               })

               // console.log('casdasfdfasdff', test)
               if(approversDropDown.length !== 0){
                     let valuesToSend = {
                        documentDate: values.documentDate,
                        leaveTypeId: values.leaveTypeId,
                        leaveStartDate: values.leaveStartDate,
                        leaveEndDate: values.leaveEndDate,
                        durationType: values.durationType,
                        leaveDay: values.leaveDay,
                        description: values.description,
                        approveStatus: ModalConfirmFormStatus,
                        approvers: approversDropDown,
                        attachFiles,
                        department: detailProfile.department,
                        division: detailProfile.division,
                        orgCode: detailProfile.orgCode,
                        orgName: detailProfile.organizationName,
                        employeeName: detailProfile.empName,
                        isReqByEmp: true,
                        autoApprove: false,
                        clientType: "WEB_CLIENT",
                        subDeptCode: detailProfile.subDeptCode,
                        subDeptName: detailProfile.subDeptName,
                        childSubDeptCode: detailProfile.childSubDeptCode,
                        childSubDeptName: detailProfile.childSubDeptName,
                     }

                     if(values.durationType == 'Custom'){
                        valuesToSend.shiftTime = values.shiftTime;
                        valuesToSend.shiftCode = values.shiftCode;
                        valuesToSend.leaveStartTime = values.leaveStartTime;
                        valuesToSend.leaveEndTime = values.leaveEndTime;
                        valuesToSend.leaveHour = leaveHour;
                        valuesToSend.shiftId = shiftId;
                     }

                     const { data, errors } = await client.mutate({
                        mutation: Mutations.createLeaveDocument,
                        variables: {
                           ...valuesToSend
                        }
                     })

                     if(data){
                        if(ModalConfirmFormStatus == 'D'){
                           message.success("บันทึกร่างสำเร็จ")
                        }else{
                           message.success("ส่งเพื่อดำเนินการเรียบร้อย")
                        }
                        await this.setState({
                           preLoadOnsubmit: false,
                           loadingFullpage: false
                        })
                        setTimeout(() => {
                           window.location.href = '/Leave/search/'
                        }, 1000);
                     }else{
                     await this.setState({
                        preLoadOnsubmit: false,
                        loadingFullpage: false
                     })
                  }
               }else{
                     Modal.error({
                        title: 'ไม่พบข้อมูลการตั้งค่าผู้อนุมัติ กรุณาติดต่อผู้ดูแลระบบ',
                        className:'custom-modal-error',
                        okText: 'ตกลง',
                     });

                     await this.setState({
                        preLoadOnsubmit: false,
                        loadingFullpage: false
                     })
               }
            }
         }catch (error) {
            await this.setState({
               preLoadOnsubmit: false,
               loadingFullpage: false
            })
            // setTimeout(() => {
            //    window.location.href = '/Leave/search/'
            // }, 1000);
            console.log('error',error)
         }
    }


    showModalFormConfirm = async (e, status, messageShow, title, textBtnOK) =>{
      const { form, client } = this.props
        this.setState({
            preLoadOnsubmit: true,
            // loadingFullpage: true
        })

         e.preventDefault()
		   form.validateFields(async (err, values) => {
            if (!err) {
               try {
                  if(status == 'D'){
                     await this.setState({
                        ModalConfirmFormStatus: status
                     })
                     await this.sendToCreateLeave(values)
                  }else{
                     let ModalFormTextAreaRequie = false
                     let ModalFormTextArea = false
                     // if(status == 'REJECT' || status == 'MOREINFO' || status == 'CANCELDOC'){
                     //     ModalFormTextArea = true
                     //     ModalFormTextAreaRequie = true
                     // }else if(status == 'APPROVE'){
                     //     ModalFormTextArea = requireNote ? true : false
                     //     ModalFormTextAreaRequie = requireNote ? true : false
                     // }

                     await this.setState({
                        ModalConfirmFormTitle:title,
                        ModalConfirmFormShowModal:true,
                        ModalConfirmFormBtnOk:textBtnOK,
                        ModalConfirmFormBtnCancel:'ยกเลิก',
                        ModalConfirmFormValue:values,
                        ModalConfirmFormStatus: status,
                        ModalConfirmFormMessage: messageShow,
                        ModalFormTextArea,
                        ModalFormTextAreaRequie
                     })
                  }
                  
               }catch (error) {
                  await this.setState({
                     preLoadOnsubmit: false,
                     // loadingFullpage: false
                  })
                  console.log('error',error)
               }
            }else{
               await this.setState({
                  preLoadOnsubmit: false,
                  // loadingFullpage: false
               })
         }
		})
    }

    hideModalConfirm = async () =>{
      await this.setState({
          ModalConfirmFormTitle:null,
          ModalConfirmFormSubTitle:null,
          ModalConfirmFormShowModal:false,
          ModalConfirmFormBtnOk:null,
          ModalConfirmFormBtnCancel:null,
          ModalConfirmFormValue:null,
          ModalConfirmFormStatus:null,
          ModalConfirmFormMessage:null,
          preLoadOnsubmit: false
      })
  }
    
   handleSubmit = async (e) => {
      const { form } = this.props
      const { 
         isCanLeaveOver, 
         remainLeaveDay, 
         leaveDay, 
         maxLeaveDay, 
         minLeaveDay, 
         reqAttachDay, 
         earlyLeaveDay, 
         disabledDateStart, 
         backLeaveDay, 
         leaveTypeCategory,
         approveStatus,
         leaveHour,
         labelTypeLeave
      } = this.state
      e.preventDefault()
      
      form.validateFields(async (err, values) => {
         if (!err) {
            console.log('valuedddssfs', values)
            var formData = this.props.form.getFieldsValue();
            let dayStart = moment(formData.leaveStartDate, 'YYYY-MM-DD');
            let dayEnd = moment(formData.leaveEndDate, 'YYYY-MM-DD');
            const monthStartDate = parseInt(dayStart.format('MM'));
            const monthEndDate = parseInt(dayEnd.format('MM'));

            let currentDay = moment(new Date())
            currentDay = moment(currentDay).format('YYYY-MM-DD')
            let startDay = moment(formData.leaveStartDate).format('YYYY-MM-DD')
            let checkBackLeaveDay = moment(startDay).isBefore(currentDay);
            let checkEarlyLeaveDay = moment(currentDay).isBefore(startDay);

            if (monthStartDate <= 9 && monthEndDate >= 10) {
               Modal.error({
                     className:"custom-modal-error",
                     title: 'ส่งดำเนินการไม่สำเร็จ',
                     width:"600px",
                     content: (
                        <h3 className="mt-3">ไม่สามารถลาข้ามปีงบประมาณได้</h3>
                     ),
                     okText: 'ปิด',
                     onOk() {},
                  });
            }else if(maxLeaveDay > 0 && leaveDay > maxLeaveDay){
                  Modal.error({
                     className:"custom-modal-error",
                     title: 'ส่งดำเนินการไม่สำเร็จ',
                     width:"600px",
                     content: (
                        <h3 className="mt-3">{labelTypeLeave}ไม่เกิน { maxLeaveDay } วัน ต่อครั้ง</h3>
                     ),
                     okText: 'ปิด',
                     onOk() {},
                  });
            }else if (isCanLeaveOver == false && remainLeaveDay < leaveDay &&  leaveTypeCategory !== 'Custom') {
                  Modal.error({
                     className:"custom-modal-error",
                     title: 'ส่งดำเนินการไม่สำเร็จ',
                     width:"600px",
                     content: (
                        <h3 className="mt-3">วันลาไม่เพียงพอ</h3>
                     ),
                     okText: 'ปิด',
                     onOk() {},
                  });
            } else if (maxLeaveDay != 0 && maxLeaveDay < leaveDay) {
                  Modal.error({
                     className:"custom-modal-error",
                     title: 'ส่งดำเนินการไม่สำเร็จ',
                     width:"600px",
                     content: (
                        <h3 className="mt-3">วันลาไม่เพียงพอ</h3>
                     ),
                     okText: 'ปิด',
                     onOk() {},
                     // closable:({disabled:false})
                  });
            } else if (minLeaveDay != 0 && minLeaveDay < leaveDay) {
                  Modal.error({
                     className:"custom-modal-error",
                     title: 'ส่งดำเนินการไม่สำเร็จ',
                     width:"600px",
                     content: (
                        <h3 className="mt-3">
                              ต้องลาอย่างน้อย { minLeaveDay } วัน
                        </h3>
                     ),
                     okText: 'ปิด',
                     onOk() {},
                  });
            }else if(leaveDay == 0 && leaveTypeCategory != 'Custom'){
               Modal.error({
                  className:"custom-modal-error",
                  title: 'ส่งดำเนินการไม่สำเร็จ',
                  width:"600px",
                  content: (
                     <h3 className="mt-3">
                     ไม่สามารถอนุมัติวันลาได้ ไม่พบข้อมูลจำนวนวันลา
                  </h3>
                  ),
                  okText: 'ปิด',
                  onOk() {},
               });
            }else if(leaveHour == 0 && leaveTypeCategory == 'Custom'){
               Modal.error({
                  className:"custom-modal-error",
                  title: 'ส่งดำเนินการไม่สำเร็จ',
                  width:"600px",
                  content: (
                     <h3 className="mt-3">
                     ไม่สามารถอนุมัติวันลาได้ จำนวนชั่วโมงการลาไม่ถูกต้อง
                  </h3>
                  ),
                  okText: 'ปิด',
                  onOk() {},
               });
            }else if (backLeaveDay > 0 && checkBackLeaveDay) {
               let backDay = moment(new Date(), 'YYYY-MM-DD').subtract(backLeaveDay, "days")
               backDay = moment(backDay).format('YYYY-MM-DD')
               let startDay = moment(formData.leaveStartDate).format('YYYY-MM-DD')
               let validate = moment(startDay).isBefore(backDay);
               if (validate) {
                  Modal.error({
                     className:"modalFickIcons",
                     title: 'ส่งดำเนินการไม่สำเร็จ',
                     width:"600px",
                     content: (
                        <h3 className="mt-3">
                           ไม่สามารถอนุมัติวันลาได้ ลาย้อนหลังเกินกำหนด
                        </h3>
                     ),
                     okText: 'ปิด',
                     onOk() {},
                  });
               } else {
                  if(approveStatus == 'D'){
                     await this.showModalFormConfirm(e,approveStatus, '', '', '')
                  }else{
                     await this.showModalFormConfirm(e,approveStatus, 'ทำการยืนยันรายการขอลาที่เลือกเรียบร้อย', 'ท่านต้องการยื่นเอกสารการลา?', 'ยื่นเรื่องลา')
                  }
               }
            }else if (earlyLeaveDay > 0 && checkEarlyLeaveDay) {
               // alert('123123')
               let earlyDay = moment(new Date(), 'YYYY-MM-DD').add(earlyLeaveDay, 'days')
               earlyDay = moment(earlyDay).format('YYYY-MM-DD')
               let startDay = moment(formData.leaveStartDate).format('YYYY-MM-DD')
               let validate = moment(startDay).isBefore(earlyDay);

               if (validate) {
                  Modal.error({
                     className:"modalFickIcons",
                     title: 'ส่งดำเนินการไม่สำเร็จ',
                     width:"600px",
                     content: (
                        <h3 className="mt-3">
                           ไม่สามารถอนุมัติวันลาได้ ลาล่วงหน้าไม่ถึงวันที่กำหนด
                        </h3>
                     ),
                     okText: 'ปิด',
                     onOk() {},
                  });
               } else {
                  if(approveStatus == 'D'){
                     // this.sendToCreateLeave(e)
                     await this.showModalFormConfirm(e,approveStatus, '', '', '')
                  }else{
                     await this.showModalFormConfirm(e,approveStatus, 'ทำการยืนยันรายการขอลาที่เลือกเรียบร้อย', 'ท่านต้องการยื่นเอกสารการลา?', 'ยื่นเรื่องลา')
                  }
               }
            }else{
               if(approveStatus == 'D'){
                  await this.showModalFormConfirm(e,approveStatus, '', '', '')
               }else{
                  await this.showModalFormConfirm(e,approveStatus, 'ทำการยืนยันรายการขอลาที่เลือกเรียบร้อย', 'ท่านต้องการยื่นเอกสารการลา?', 'ยื่นเรื่องลา')
               }
               // this.sendToCreateLeave(e, 'W')
            }
         }else{
            Modal.error({
               className:"modalFickIcons",
               title: 'ส่งดำเนินการไม่สำเร็จ',
               width:"600px",
               content: (
                  <h3 className="mt-3">
                     กรุณาระบุข้อมูลให้ครบถ้วน
                  </h3>
               ),
               okText: 'ปิด',
               onOk() {},
            });
         }
      })
   }

    handleSubmitCancel = async (e) => {
        window.location.href = '/Leave/search/'
        // this.sendToCreateLeave(e, 'DRAFT')
    }

    disabledDate = (current) =>{
        const { disabledDateStart } = this.state
        return current && current < disabledDateStart;
    }

    disabledDateInputFirst = (current) =>{
         return current && current <= moment().add(-1,'day');
   }

   onChangeDurationType = async (e) =>{
      const { leaveDay } = this.state
      await this.setState({
         leaveTypeCategory: e
      })

      await this.props.form.setFieldsValue({
         shiftCode: null,
         shiftTime: null,
         leaveStartTime: null,
         leaveEndTime: null,
         leaveHour: null
      })

      let leaveStartDate = this.props.form.getFieldValue('leaveStartDate')
      let leaveEndDate = this.props.form.getFieldValue('leaveEndDate')
      if(leaveStartDate && leaveEndDate){
         await this.fetchWorkingDay(leaveStartDate, leaveEndDate)
      }
      if (leaveDay == 0) {
         await this.props.form.setFieldsValue({
            leaveDay: leaveDay,
        })
        await this.setState({
           leaveDay: leaveDay
        })
      } else if(e == 'H2' || e == 'H1'){
         await this.props.form.setFieldsValue({
            leaveDay: 0.5,
         })
         await this.setState({
            leaveDay: 0.5,
         })
         await this.fetchApproverLeave(this.state.leaveDay)
      }else if(e == 'Custom'){
         await this.fetchLeaveShiftTime()
      }else{
         await this.props.form.setFieldsValue({
            leaveDay: 1,
         })
         await this.setState({
            leaveDay: 1,
         })
         await this.fetchApproverLeave(this.state.leaveDay)
      }
   }

   fetchLeaveShiftTime = async () =>{
      const { client, location, match } = this.props
      const { empCode } = this.state
      const leaveStartDate = this.props.form.getFieldValue('leaveStartDate')
      let workDate = moment(leaveStartDate).format('YYYY-MM-DDT00:00:00.000')

      await this.setState({
         loadingFullpage:true
      })

      try{
         const { data, errors } = await client.query({
            query: Queries.fetchLeaveShiftTime,
            variables:{
               // workDate: "2021-05-15T00:00:00.000",
               workDate: workDate,
               empCode
            }
        })

        console.log('data.fetchLeaveShiftTim', data.fetchLeaveShiftTime)

         if(data.fetchLeaveShiftTime){
            await this.props.form.setFieldsValue({
               shiftCode: data.fetchLeaveShiftTime.shiftCode,
               shiftTime: data.fetchLeaveShiftTime.shiftTime,
            });

            await this.timeSelect(data.fetchLeaveShiftTime.shiftTime)
            await this.setState({
               loadingFullpage:false,
               shiftId: data.fetchLeaveShiftTime.shiftId,
            })
         }else{
            await this.setState({
               loadingFullpage:false,
               shiftId: null
            })
         }
      }catch (error) {
         console.log(error)
         await this.setState({
            loadingFullpage:false
         })
      }
   }

   fetchLeaveHour = async () =>{
      const { client, location, match } = this.props
      const { empCode, shiftId, leaveStartTime, leaveEndTime } = this.state
      try{
         if(leaveStartTime && leaveEndTime){
            const { data, errors } = await client.query({
               query: Queries.fetchLeaveHour,
               variables:{
                     shiftId,
                     leaveStartTime,
                     leaveEndTime
               }
            })
            
            if(data.fetchLeaveHour){
               await this.setState({
                  leaveHour: data.fetchLeaveHour.value.toString(),
                  leaveDay: data.fetchLeaveHour.value / 480
               })

               await this.props.form.setFieldsValue({
                  leaveHour: data.fetchLeaveHour.label,
                  leaveDay: data.fetchLeaveHour.value / 480
               })

               await this.fetchApproverLeave(this.state.leaveDay)
            }else{
               await this.setState({
                  leaveHour: null
               })
               await this.props.form.setFieldsValue({
                  leaveHour: ''
               })
            }
         }
      }catch (error) {
         console.log(error)
      }
   }

   onChangeleaveStartTime = async (e) =>{
      const { leaveEndTime } = this.state
      await this.setState({
         leaveStartTime: e
      })

      if(leaveEndTime){
         await this.fetchLeaveHour()
      }
   }

    onChangeLeaveEndTime = async (e) =>{
       const { leaveStartTime } = this.state
       await this.setState({
         leaveEndTime: e
      })

      if(leaveStartTime){
         await this.fetchLeaveHour()
      }
    }

    fetchLeaveDayAll = async () =>{
        const { client, location, match } = this.props
        const { empCode } = this.state
        const { data, errors } = await client.query({
            query: Queries.fetchLeaveDayAll,
            variables:{
                reqLeaveDate: moment()
            }
        })
        console.log('data.fetchLeaveDayAll', data.fetchLeaveDayAll)
        if(data.fetchLeaveDayAll){
         let leaveDayAllData = data.fetchLeaveDayAll
         // let leaveDayAllData = []
         // await data.fetchLeaveDayAll.map(valuesSelect => {
         //    if(
         //       valuesSelect.leaveTypeId == '5'
         //       // valuesSelect.leaveTypeId == '1' ||
         //       // valuesSelect.leaveTypeId == '5' ||
         //       // valuesSelect.leaveTypeId == '4'
         //    ){
         //       valuesSelect.isShowRemaVtrc = true
         //    }else{
         //       valuesSelect.isShowRemaVtrc = false
         //       // leaveDayAllData.push(valuesSelect)
         //    }

         //    leaveDayAllData.push(valuesSelect)
         // })

            await this.setState({
               leaveDayAllData,
            })
        }

        let leaveYearStartDate = data.fetchLeaveDayAll?.length > 0 ? data.fetchLeaveDayAll[0].leaveYearStartDate.split("-") : ''
        let leaveYearEndDate =data.fetchLeaveDayAll?.length > 0 ?  data.fetchLeaveDayAll[0].leaveYearEndDate.split("-") : ''

        
        await this.setState({
            loadingleaveDayAllData:false,
            historyYear: data.fetchLeaveDayAll?.length > 0 ? changeFormatdateThai(leaveYearStartDate[2]+"-"+leaveYearStartDate[1]+"-"+leaveYearStartDate[0])+' ถึง '+changeFormatdateThai(leaveYearEndDate[2]+"-"+leaveYearEndDate[1]+"-"+leaveYearEndDate[0]) : null
        })
   }

   checkLeaveDayAllValue = (value) =>{
      if(value.includes('.')){
         return numberWithCommas(value)
      }else{
         return value
      }
   }

   timeSelect = async (shiftTime) => {
      if (shiftTime) {
         const startTime = shiftTime.substring(0, 5)
         const endTime = shiftTime.substring(shiftTime.length-5, shiftTime.length)
  
         await this.setState({
           dropdownTimeLeave: timeLeave(startTime, endTime)
        })
      }
  }

   fetchMasterConfigTypeLeave = async () =>{
      const { client, location, match } = this.props

      const { data, errors } = await client.query({
         query: Queries.fetchMasterConfigTypeLeave,
      })
      if(data.fetchMasterConfigTypeLeave){
         console.log('fetchMasterConfigTypeLeave', data.fetchMasterConfigTypeLeave)
         let manualLeave = data.fetchMasterConfigTypeLeave.filter(valuesArray => valuesArray.configType == "Manual")
         let remarkText = data.fetchMasterConfigTypeLeave.filter(valuesArray => valuesArray.configType == "Remark")
         await this.setState({
            remarkText: remarkText ? remarkText[0].configValue1 : null,
            manualLeave
         })
      }
   }

	async componentDidMount(){
      await Promise.all(
         [
            this.fetchProfileForLeave(),
            this.fetchLeaveDayAll(),
            this.dropdownLeaveType(),
            this.fetchMasterConfigTypeLeave()
         ]
      )
    }

	render() {
		const { match } = this.props
        const { getFieldDecorator } = this.props.form
        const { 
            columns, 
            preLoadOnsubmit, 
            dataTalbeUploads, 
            dropdownApproverMedical,
            detailProfile,
            showleaveDay,
            currentLeaveDay,
            remainLeaveDay,
            disabledDateStart,
            endStartValues,
            dropdownLeaveType,
            dropdowndurationType,
            disabledDurationType,
            preLoadOndropdownApproverMedical,
            loadingFullpage,
            leaveDayAllData,
            loadingleaveDayAllData,
            leaveTypeId,
            ModalConfirmFormTitle,
            ModalConfirmFormSubTitle,
            ModalConfirmFormShowModal,
            ModalConfirmFormBtnOk,
            ModalConfirmFormBtnCancel,
            ModalConfirmFormValue,
            ModalFormTextArea,           
            ModalFormTextAreaRequie,
            leaveTypeCategory,
            leaveHour,
            historyYear,
            shiftId,
            dropdownTimeLeave,
            remarkText,
            modalGuideLineTax,
            manualLeave,
            preloadProfile
        } = this.state

        console.log('remarkText',detailProfile)

		return (
            <Container match={match}>
                <div className="breadcrumb-custom pb-3 mb-5">
                    {/* <Breadcrumb.Item> */}
                        <span style={{ fontSize:"18px" }}>การลา / เพิ่มคำขอลา </span>
                    {/* </Breadcrumb.Item> */}
                </div>

               <ModalConfirmForm 
                  title={ModalConfirmFormTitle} 
                  subtitle={ModalConfirmFormSubTitle}
                  showModal={ModalConfirmFormShowModal} 
                  btnOk={ModalConfirmFormBtnOk} 
                  btnCancel={ModalConfirmFormBtnCancel}  
                  submitToSend={ this.sendToCreateLeave }
                  hideModal={ this.hideModalConfirm }
                  valueConfirm = { ModalConfirmFormValue }
                  ModalFormTextArea = {ModalFormTextArea}
                  ModalFormTextAreaRequie = {ModalFormTextAreaRequie}
               />

               {
                  detailProfile ?
                     <Spin spinning={loadingFullpage} delay={500}>
                        <div className="card-container h-100" id="page-profile">
                           <Form ref={this.formRef} onSubmit={this.handleSubmit}>
                              <div className="px-5 pt-1 pb-4 card-bg-green">
                                    <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                       <Col xs={24} md={24} className="pt-2">
                                          <strong className="color-red">
                                                ข้อมูลบุคลากร
                                          </strong>
                                       </Col>

                                       <Col xs={24} md={8} className="pt-2 mb-1">
                                          <FromInput disabled={true} value={detailProfile.empName} required={false} name={"name"} label="ชื่อบุคลากร" mode={"text"} />
                                       </Col>

                                       <Col xs={24} md={8} className="pt-2 mb-1">
                                          <FromInput disabled={true} value={detailProfile.division ? detailProfile.division : '-'} required={false} name={"diviName"} label="ฝ่าย" mode={"text"} />
                                       </Col>

                                       <Col xs={24} md={8} className="pt-2 mb-1">
                                          <FromInput disabled={true} value={detailProfile.department ? detailProfile.department : '-'} required={false} name={"deptName"} label="หน่วยงาน" mode={"text"} />
                                       </Col>

                                       <Col xs={24} md={8} className="pt-2 mb-1">
                                          <FromInput disabled={true} value={detailProfile.subDeptName ? detailProfile.subDeptName : '-'} required={false} name={"subDeptName"} label="งาน" mode={"text"} />
                                       </Col>
                                       {/* <Col xs={24} md={8} className="pt-2 mb-1">
                                          <FromInput hidden disabled={true} value={detailProfile.childSubDeptName ? detailProfile.childSubDeptName : '-'} required={false} name={"childSubDeptName"} label="lv5" mode={"text"} />
                                       </Col> */}
                                       
                                    </Row>

                                    <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                       <Col xs={24} md={12} className="pt-2">
                                          <strong className="color-red">
                                             ข้อมูลการลา
                                          </strong>
                                       </Col>
                                       <Col xs={24} md={12} className="pt-2 text-right">
                                          {
                                             manualLeave.length > 0 ?
                                                <>
                                                   <div align="right" className="div-guild-line">
                                                         <p  style={{width:"auto", cursor:"pointer", textDecoration:"underline", color:"blue"}} onClick={ async () => this.setState({modalGuideLineTax:true}) }>
                                                            คู่มือการใช้งาน 
                                                         </p>
                                                      </div>

                                                      <Modal
                                                         destroyOnClose={true}
                                                         visible={modalGuideLineTax}
                                                         maskClosable={false}
                                                         title={"คู่มือการใช้งาน"}
                                                         onCancel={ async () => await this.setState({modalGuideLineTax:false})}
                                                         width={600}
                                                         okText={ "" }
                                                         cancelText={ "ปิด" }
                                                         footer={null}
                                                      >
                                                         <Row gutter={16} type="flex" justify="left" align="top" >
                                                            <Col xs={24} md={24} >
                                                               <ol className="pl-3">
                                                               {
                                                                   manualLeave.map((values, keys)=>{
                                                                     if(values.typeValue == 'file'){
                                                                        return <li className="mb-2">
                                                                                 <a style={{ textDecoration:"underline" }} href={ checkLinkURL()+values.configValue2 } target="_blank">{ values.configValue1 }</a>
                                                                              </li>
                                                                     }else if(values.typeValue == 'link'){
                                                                        return <li className="mb-2">
                                                                                 <a style={{ textDecoration:"underline" }} href={ values.configValue2 } target="_blank">{ values.configValue1 }</a>
                                                                              </li>
                                                                     }
                                                                  })
                                                               }
                                                               </ol>
                                                            </Col>

                                                            <Col xs={24} md={24} align="right">
                                                               <Button 
                                                                  type="primary " 
                                                                  className="mt-1 color-white"
                                                                  htmlType="submit"
                                                                  onClick={ async () => await this.setState({modalGuideLineTax:false}) }
                                                               >
                                                                  ปิด
                                                               </Button>
                                                            </Col>
                                                         </Row>
                                                        
                                                      </Modal>
                                                </>
                                             :
                                             ''
                                          }
                                       </Col>
                                       <Col xs={24} md={12} className="pt-2 mb-1">
                                          <FromInput disabled={true} value={'-'} required={false} name={"docId"} label="เลขที่เอกสาร" mode={"text"} />
                                       </Col>
                                       <Col xs={24} md={12} className="pt-2 mb-1">
                                          <FromInput disabled={true} value={'-'} required={false} name={"status"} label="สถานะเอกสาร" mode={"text"} />
                                       </Col>
                                       <Col xs={24} md={12} className="pt-2 mb-1">
                                          <Form.Item label={'วันที่ยื่นเรื่อง'} className="mb-0">
                                                { getFieldDecorator('documentDate', {
                                                   initialValue: moment(),
                                                   rules:  [{ 
                                                      required:true, 
                                                      message: 'กรุณาระบุ  วันที่ยื่นเรื่อง',
                                                   }],
                                                })(
                                                   <DatePicker 
                                                      format={this.dateFormatNumber("documentDate")} 
                                                      placeholder="" 
                                                      style={{ width:"100%" }} 
                                                      disabled={true}
                                                   />
                                                )}
                                          </Form.Item>
                                       </Col>
                                       
                                       <Col xs={24} md={12} className="pt-2 mb-1">
                                          <Form.Item label={"ประเภทการลา"} className="mb-0">
                                                { this.props.form.getFieldDecorator("leaveTypeId", {
                                                   rules:  [{ 
                                                      required: true, 
                                                      message: 'กรุณาเลือก ประเภทการลา',
                                                   }],
                                                })(
                                                   <Select 
                                                      style={{ width: "100%" }}
                                                      showSearch
                                                      placeholder="กรุณาระบุ "
                                                      optionFilterProp="children"
                                                      onChange={ (e) => this.onChangeTypeLeave(e) }
                                                   >
                                                      {
                                                            dropdownLeaveType.length !== 0 ? 
                                                               dropdownLeaveType.map((valuseLabel, keysLabel) =>{
                                                                  return <Option value={valuseLabel.value}>{ valuseLabel.label }</Option>
                                                               })
                                                            : ''
                                                      }
                                                   </Select>
                                                )}
                                          </Form.Item>
                                       </Col>
                                       <Col xs={ 24 } md={12}>
                                          <Form.Item label="วันที่เริ่มลา" className="mb-0">
                                                { getFieldDecorator('leaveStartDate', {
                                                   initialValue: disabledDateStart,
                                                   rules:  [{ 
                                                      required: true, 
                                                      message: 'กรุณาระบุ  วันที่เริ่มลา',
                                                   }],
                                                })(
                                                   <DatePicker 
                                                      format={this.dateFormatNumber("leaveStartDate")} 
                                                      //   disabledDate={this.disabledDateInputFirst} 
                                                      className="w-100"  
                                                      placeholder="ระบุ วันที่" 
                                                      disabled = {  leaveTypeId ? false : true  }
                                                      allowClear={false}
                                                      onChange={(e) => this.onChangeValueDateStart(e)}
                                                   />
                                                )}
                                          </Form.Item>
                                       </Col>
                                       
                                       <Col xs={ 24 } md={12}>
                                          <Form.Item label="วันที่สิ้นสุดการลา" className="mb-0">
                                                { getFieldDecorator('leaveEndDate', {
                                                   initialValue: endStartValues,
                                                   rules:  [{ 
                                                      required:true,
                                                      message: 'กรุณาระบุ วันที่สิ้นสุดการลา',
                                                   }],
                                                })(
                                                   <DatePicker 
                                                      format={this.dateFormatNumber("leaveEndDate")} 
                                                      disabledDate={this.disabledDate} 
                                                      disabled={ leaveTypeId ?  !disabledDateStart ? true : false : true  }
                                                      className="w-100" 
                                                      // defaultValue={ valuesEndDate ? moment(valuesEndDate) : '' } 
                                                      placeholder="ระบุ วันที่"
                                                      allowClear={false}
                                                      onChange={(e) => this.onChangeValueDateEnd(e)}
                                                   />
                                                )}
                                          </Form.Item>
                                       </Col>

                                       <Col xs={24} md={12}>
                                          <Form.Item label={"ช่วงเวลาการลา"}  className="mb-0">
                                                { this.props.form.getFieldDecorator("durationType", {
                                                   rules:  [{ 
                                                      required: true, 
                                                      message: 'กรุณาเลือก ช่วงเวลาการลา',
                                                   }],
                                                })(
                                                   <Select 
                                                      style={{ width: "100%" }}
                                                      showSearch
                                                      placeholder=""
                                                      optionFilterProp="children"
                                                      disabled={ disabledDurationType ? true : false }
                                                      onChange={ (e) => this.onChangeDurationType(e) }
                                                   >
                                                      {
                                                            dropdowndurationType.length !== 0 ? 
                                                               dropdowndurationType.map((valuseLabel, keysLabel) =>{
                                                                  return <Option value={valuseLabel.value}>{ valuseLabel.label }</Option>
                                                               })
                                                            : ''
                                                      }
                                                   </Select>
                                                )}
                                          </Form.Item>
                                       </Col>

                                       <Col xs={24} md={12} >
                                          <div hidden={leaveTypeCategory == 'Custom' ? true : false}>
                                             <Form.Item label={"จำนวนวันลา"} className="mb-0">
                                                   { this.props.form.getFieldDecorator("leaveDay", {
                                                      rules:  [{ 
                                                         required: true, 
                                                         message: 'กรุณาระบุ จำนวนวันลา',
                                                      }],
                                                   })(
                                                      <Input 
                                                         className='block-news' 
                                                         disabled={true}
                                                      />
                                                   )}
                                             </Form.Item>
                                         </div>
                                       </Col>

                                       {
                                             leaveTypeCategory == 'Custom' &&
                                             <>
                                                <Col xs={24} md={12}>
                                                   <Form.Item label={"รหัสกะงาน"} className="mb-0">
                                                      { this.props.form.getFieldDecorator("shiftCode", {
                                                         rules:  [{ 
                                                            // required: true, 
                                                            message: 'กรุณากรอกระบุ รหัสกะงาน',
                                                         }],
                                                      })(
                                                         <Input 
                                                            className='block-news' 
                                                            disabled={true}
                                                         />
                                                      )}
                                                   </Form.Item>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                   <Form.Item label={"เวลาทำงานของกะงาน"} className="mb-0">
                                                      { this.props.form.getFieldDecorator("shiftTime", {
                                                         rules:  [{ 
                                                            // required: true, 
                                                            message: 'กรุณากรอกระบุ ช่วงเวลาการลา',
                                                         }],
                                                      })(
                                                         <Input 
                                                            className='block-news' 
                                                            disabled={true}
                                                         />
                                                      )}
                                                   </Form.Item>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                   <Form.Item label={"เวลาเริ่มต้น"} className="mb-0">
                                                      { this.props.form.getFieldDecorator("leaveStartTime", {
                                                         rules:  [{ 
                                                            required: false, 
                                                            message: 'กรุณากรอกระบุ เวลาเริ่มต้น',
                                                         }],
                                                      })(
                                                         // <TimePicker 
                                                         //    format={format} 
                                                         //    className="w-100"
                                                         //    placeholder="" 
                                                         //    onChange={ this.onChangeleaveStartTime }
                                                         //    disabled={ !shiftId ? true : false }
                                                         // />
                                                         <Select 
                                                            style={{ width: "100%" }}
                                                            showSearch
                                                            placeholder=""
                                                            optionFilterProp="children"
                                                            disabled={ !shiftId ? true : false }
                                                            onChange={ (e) => this.onChangeleaveStartTime(e) }
                                                         >
                                                            {
                                                                  dropdownTimeLeave.length !== 0 ? 
                                                                     dropdownTimeLeave.map((valuseLabel, keysLabel) =>{
                                                                        return <Option value={valuseLabel.value}>{ valuseLabel.label }</Option>
                                                                     })
                                                                  : ''
                                                            }
                                                         </Select>
                                                      )}
                                                   </Form.Item>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                   <Form.Item label={"เวลาสิ้นสุด"} className="mb-0">
                                                      { this.props.form.getFieldDecorator("leaveEndTime", {
                                                         rules:  [{ 
                                                            required: false, 
                                                            message: 'กรุณากรอกระบุ เวลาสิ้นสุด',
                                                         }],
                                                      })(
                                                         // <TimePicker 
                                                         //    format={format} 
                                                         //    className="w-100"
                                                         //    placeholder="" 
                                                         //    onChange={ this.onChangeLeaveEndTime }
                                                         //    disabled={ !shiftId ? true : false }
                                                         // />
                                                         <Select 
                                                            style={{ width: "100%" }}
                                                            showSearch
                                                            placeholder=""
                                                            optionFilterProp="children"
                                                            disabled={ !shiftId ? true : false }
                                                            onChange={ (e) => this.onChangeLeaveEndTime(e) }
                                                         >
                                                            {
                                                                  dropdownTimeLeave.length !== 0 ? 
                                                                     dropdownTimeLeave.map((valuseLabel, keysLabel) =>{
                                                                        return <Option value={valuseLabel.value}>{ valuseLabel.label }</Option>
                                                                     })
                                                                  : ''
                                                            }
                                                         </Select>
                                                      )}
                                                   </Form.Item>
                                                </Col>

                                                <Col xs={24} md={12}>
                                                   <Form.Item label={"จำนวนชั่วโมงการลา"} className="mb-0">
                                                      { this.props.form.getFieldDecorator("leaveHour", {
                                                         rules:  [{ 
                                                            // required: true, 
                                                            message: 'กรุณากรอกระบุ จำนวนชั่วโมงการลา',
                                                         }],
                                                      })(
                                                         <Input 
                                                            className='block-news' 
                                                            disabled={true}
                                                         />
                                                      )}
                                                   </Form.Item>
                                                </Col>
                                             </>
                                          }

                                       <Col xs={24} md={24}  className="">
                                          <Form.Item label={"เหตุผลการลา"}>
                                                { getFieldDecorator("description", {
                                                   initialValue: "",
                                                   rules:  [{ 
                                                      required: true, 
                                                      message: 'กรุณาระบุ  เหตุผลการลา',
                                                   }],
                                                })(
                                                   <TextArea rows={3} className='block-news' />
                                                )}
                                          </Form.Item>
                                       </Col>

                                       <Col xs={24} md={24}  className="" >
                                          {
                                             remarkText &&
                                             <ComponetsRemarkText remarkText={remarkText}/>
                                          }
                                       </Col>
                                    </Row>

                                    {/* <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white">
                                       <Col xs={24} md={24} >
                                          <TableCCEmail 
                                             getFieldDecorator= {getFieldDecorator}
                                             detailProfile = {detailProfile}
                                          />
                                       </Col>
                                    </Row> */}


                                    {  
                                       leaveDayAllData.length  > 0 &&
                                          <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white">
                                             <Col xs={24} md={24} className="mb-5">
                                                <strong className="color-red">
                                                   ประวัติการลาประจำปี {historyYear}
                                                </strong>
                                             </Col>
                                             <Col xs={24} md={24}>
                                                <Row gutter={16} type="flex"  align="top" className="box-show-number px-4 mb-4">
                                                      {/* <Col xs={24} md={6} className="" align={"center"} style={{ borderRight:"1px solid #c5c4c4" }}> */}
                                                      <Col xs={24} md={9} className="" align={"center"}>
                                                         <strong className="">
                                                            ประเภทการลา
                                                         </strong>
                                                      </Col>
                                                      <Col xs={24} md={5} className="" align={"right"}>
                                                         <strong className="">
                                                            สิทธิการลา
                                                         </strong>
                                                      </Col>
                                                       <Col xs={24} md={5} className="" align={"right"}>
                                                         <strong className="color-orange">
                                                            วันลาคงเหลือ
                                                         </strong>
                                                      </Col>
                                                      <Col xs={24} md={5} className="" align={"right"}>
                                                         <strong className="color-green">
                                                            วันลาที่ใช้ไปแล้ว
                                                         </strong>
                                                      </Col>
                                                </Row>
                                                {
                                                   leaveDayAllData.map((values, keys)=>{
                                                      return   values.isShowRemaVtrc || values.currentLeaveDay ? 
                                                                  <Row type="flex" gutter={16}  align="top" className="box-show-number  px-4 ">
                                                                     <Col xs={24} md={8} className="" align={"left"}>
                                                                           <p className="mb-1">
                                                                              {values.leaveTypeName}<br></br>
                                                                           </p>
                                                                     </Col>
                                                                     
                                                                     <Col xs={24} md={5} className="" align={"right"}>
                                                                           <strong className={ values.leaveDay || values.leaveDay == 0 ? 'numberLeav' : '' }>
                                                                              { values.isShowRemaVtrc ? values.leaveDay || values.leaveDay == 0 ? convertLeaveDayUnit(values.leaveDay) : '-' : '-' }
                                                                           </strong>
                                                                     </Col>
                                                                     <Col xs={24} md={5} className="" align={"right"}>
                                                                           <strong className={values.remainLeaveDay || values.remainLeaveDay == 0 ? 'numberLeav color-orange' : 'color-orange'}>
                                                                              { values.isShowRemaVtrc ? values.remainLeaveDay || values.remainLeaveDay == 0 ? convertLeaveDayUnit(values.remainLeaveDay.toString()) : '-' : '-' }
                                                                           </strong>
                                                                     </Col>
                                                                     <Col xs={24} md={5} className="" align={"right"}>
                                                                           <strong className={values.currentLeaveDay || values.currentLeaveDay == 0 ? 'numberLeav color-green' : 'color-green'}>
                                                                              { values.currentLeaveDay || values.currentLeaveDay == 0 ? convertLeaveDayUnit(values.currentLeaveDay.toString()) : '-' }
                                                                           </strong>
                                                                     </Col>
                                                                     
                                                                     <Col md={24}>
                                                                        <hr></hr>
                                                                     </Col>
                                                                  </Row>
                                                               :
                                                               ''
                                                   })
                                                }
                                             </Col>
                                          </Row>
                                    }

                                    <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                       <Col xs={24} md={24} className="pt-2 mb-3">
                                          <strong className="color-red">
                                                เอกสารแนบ
                                          </strong>
                                       </Col>
                                       
                                       <Col xs={24} md={24} align={"right"}>
                                          <Table
                                                columns={columns}
                                                dataSource={dataTalbeUploads}
                                                pagination={false}
                                                className="mb-3"
                                                bordered
                                                // rowCount={dataTalbeUploads.length}
                                                // pagination={{ pageSize: dataTalbeUploads.length }}
                                          />
                                          <Button 
                                                style={{ display:"inline-block" }}
                                                type="primary btn-color-default btn-custom btn-clear color-white" 
                                                className="mt-1 mr-2"
                                                onClick={ () => this.showDataInputUploads() }
                                          >
                                                เพิ่มเอกสารแนบ +
                                          </Button>
                                       </Col>
                                    </Row>
                           
                                    {
                                       dropdownApproverMedical.length > 0 &&
                                          <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white">
                                             {
                                                !preLoadOndropdownApproverMedical ?
                                                      dropdownApproverMedical.length !== 0 ? 
                                                         dropdownApproverMedical.map((valuseLabel, keysLabel) =>{
                                                            return <Col xs={24} md={24} className="pt-2 mb-1">
                                                                        {/* <Form.Item label={valuseLabel.approveLabel} style={{width:"50%"}}> */}
                                                                        <Form.Item label={checkNameApproves(dropdownApproverMedical.length, (parseInt(keysLabel)+1))} style={{width:"50%"}}>
                                                                                 { getFieldDecorator("approversDropDown"+keysLabel+"", {
                                                                                    initialValue: valuseLabel.users.length == 1 ? valuseLabel.users[0].value : [],
                                                                                    rules:  [{ 
                                                                                          required: true, 
                                                                                          message: 'กรุณาเลือก ชื่อผู้อนุมัติ',
                                                                                    }],
                                                                                 })(
                                                                                    <Select 
                                                                                       style={{ width: "100%" }}
                                                                                       placeholder={'กรุณาเลือก ชื่อผู้อนุมัติ' }
                                                                                    >
                                                                                          {/* <Option value={''}>ไม่ระบุ { valuseLabel.approveLabel }</Option> */}
                                                                                          { 
                                                                                             valuseLabel.users.map((valueSelect, keysSelect) =>{
                                                                                                return <Option value={ valueSelect.value ? valueSelect.value : '1' }>{ valueSelect.label }</Option>
                                                                                             })
                                                                                          }
                                                                                    </Select>
                                                                                 )}
                                                                        </Form.Item>
                                                                     </Col>
                                                         })
                                                      : ''
                                                :
                                                      <Row>
                                                         <Col align="center" span={24} className="mt-5">
                                                            <Spin size="small" />
                                                         </Col>
                                                      </Row>
                                             }                          
                                          </Row>
                                    }

                                    <Row gutter={16} type="flex" justify="left" align="top">
                                       <Col xs={24} md={24} align={"center"} className="mt-4">
                                          <Button type="primary" className="mx-2 btn-white-red" onClick={this.handleSubmitCancel} disabled={ preLoadOnsubmit }>
                                             ย้อนกลับ
                                          </Button>
                                          <Button 
                                             type="primary" 
                                             className="mx-2 btn-white-red" 
                                             htmlType="submit" 
                                             onClick={ async () => {
                                                await this.setState({
                                                   approveStatus: 'D',
                                                })
                                                await this.handleSubmit
                                             }} 
                                             disabled={ preLoadOnsubmit }
                                          >
                                             บันทึกร่าง
                                          </Button>
                                          <Button 
                                             type="primary" 
                                             className="ml-2 color-white" 
                                             htmlType="submit" 
                                             disabled={ preLoadOnsubmit }
                                             onClick={ async () => {
                                                await this.setState({
                                                   approveStatus: 'W'
                                                })
                                                await this.handleSubmit
                                             }} 
                                          >
                                             ยื่นเรื่องลา
                                          </Button>
                                       </Col>
                                    </Row>
                              </div>
                           </Form>
                        </div>
                     </Spin>
                  : 
                     preloadProfile &&
                     <div className="pt-4 mt-3" style={{ textAlign: 'center', borderRadius: "10px", height: "130px" }}>
                        <Icon type="loading" />
                     </div>
                }
                
            </Container>
		)
	}
}

Withdraw.defaultProps = {
	autoFocus: false
}

Withdraw.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedWithdraw = Form.create()(Withdraw)

export default withApollo(WrappedWithdraw)